import React from 'react';
import { connect } from 'react-redux';
import { IAuthorizationProps } from './authorization-props';
import { hasBuckets } from './buckets';
import { Navigation } from '../../global-functions';
import { RootState } from '../../store';

const withBucket =
    (buckets: number[]) =>
    <P extends object>(WrappedComponent: React.ComponentType<P>) => {
        const Wrapper = ({ session, ...rest }: IAuthorizationProps) => {
            let children;

            if (hasBuckets(session, buckets)) {
                children = <WrappedComponent {...(rest as P)} />;
            } else {
                Navigation.pushExternal('/');
            }

            return <>{children}</>;
        };

        const mapStateToProps = (state: RootState) => ({
            session: state.session!.data!,
        });

        return connect(mapStateToProps)(Wrapper);
    };

export default withBucket;
